import React from 'react';
import { SvgIcon } from './svg-icon';

export const Key = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M15.3334 3C12.2 3 9.6667 5.53334 9.6667 8.66667C9.6667 9.33334 9.80003 10 10 10.6667L3 17.6667V21.0001H6.33335V19.0001H8.33336V17.0001H10.3334L13.3334 14.0001C13.9334 14.2 14.6 14.3334 15.3334 14.3334C18.4667 14.3334 21 11.8 21 8.66671C21 5.53338 18.4667 3 15.3334 3ZM17.0001 9.00003C15.8667 9.00003 15.0001 8.13337 15.0001 7.00002C15.0001 5.86666 15.8667 5.00001 17.0001 5.00001C18.1334 5.00001 19.0001 5.86666 19.0001 7.00002C19.0001 8.13337 18.1334 9.00003 17.0001 9.00003Z" />
  </SvgIcon>
);
